import type { UserState } from '@app/store/user'

import type { UserWithAvatar } from './types'

const POST_AD_PATH_BY_LANGUAGE: Record<string, string> = {
  en: '/let-your-home',
  fr: '/loue-ton-appartement',
  de: '/wohnung-vermieten',
  it: '/affitta-il-tuo-appartamento',
}

const DEFAULT_POST_AD_PATH = POST_AD_PATH_BY_LANGUAGE.en

export const getProfileAvatarUrl = (userState: UserState): string => {
  const currentUser = userState.currentUser as UserWithAvatar

  return (
    currentUser.avatar ||
    'https://res.listglobally.com/puzzle/Agent_picture_empty'
  )
}

export const getProfileUsername = (userState: UserState): string => {
  return userState.currentUser.fullName || ''
}

export const getProfileEmail = (userState: UserState): string => {
  return userState.currentUser.email || ''
}

export const getPostAdPath = (languageCode: string): string => {
  return POST_AD_PATH_BY_LANGUAGE[languageCode] || DEFAULT_POST_AD_PATH
}
